import { createSlice } from '@reduxjs/toolkit'
import { initialFields } from './universityFormFields'

const initialState = {
  fields: initialFields,
}

const universityFormSlice = createSlice({
  name: 'universityForm',
  initialState,
  reducers: {
    setFields(state, action) {
      state.fields = action.payload
    },
    resetFields(state) {
      state.fields = initialFields
    }
  },
})

export const { setFields, resetFields } = universityFormSlice.actions
export default universityFormSlice.reducer
